export enum ExpenditureOptions {
  ExpendituresInHours = 'hourly_expenditure', // These are expenditures that cannot be billed / invoiced.
  HourlyRateFixed = 'expenditure_hourly_rate_fixed',
  HourlyRatePerMember = 'expenditure_hourly_rate_per_member',
  HourlyRatePerTask = 'expenditure_hourly_rate_per_task',
}

export enum BudgetOptions {
  NoBudget = 'budget_none',
  TotalProjectMonetaryBudget = 'budget_fixed_monetary',
  TotalProjectHours = 'budget_total_project_hours',
  MonetaryPerTask = 'budget_monetary_per_task',
  HoursPerTask = 'budget_hours_per_task',
  HoursPerMember = 'budget_hours_per_member',
}

export enum InvoiceType {
  TimeAndMaterial = 'time_and_material',
}
